import { ReportColumnConfig } from "components/ReportGrid_New/types";

export const DETAILED_CYCLE_TIME_REPORT_TITLE =
  'Detailed Cycle Time Report with Exceptions';

export const DETAILED_CYCLE_TIME_REPORT_MESSAGE =
  'Provides a detailed breakdown of claims and their cycle times using the same criteria as the Cycle Time screen - this report also includes Exceptions that show why jobs do NOT appear on the Cycle Time Screen (Version 2)';

export const DETAILED_CYCLE_TIME_REPORT_GRID_TITLE =
  'DetailedCycleTimeReport_wEX_V2';

export const columnsList = (showExcep: boolean): ReportColumnConfig[] => [
  { name: 'repairer', title: 'Repairer', width: '200' },
  { name: 'stream', title: 'Stream' },
  { name: 'manufacturer', title: 'Manufacturer' },
  { name: 'activeWebID', title: 'ActiveWebID' },
  { name: 'registration', title: 'Registration' },
  { name: 'hours', title: 'Hours' },
  { name: 'fnolToOnsite', title: 'FNOL to On Site' },
  { name: 'onSiteToStarted', title: 'Onsite to Started' },
  { name: 'startedToCompleted', title: 'Started to Completed' },
  { name: 'completedToDelivered', title: 'Completed to Delivered' },
  { name: 'keyToKey', title: 'Key to Key' },
  {
    name: showExcep ? 'fnolToDelivered' : 'fnolToInvoiced',
    title: showExcep ? 'FNOL to Delivered' : 'FNOL to Invoiced',
  },
  { name: 'affectsCycleTime', title: 'Affects CycleTime' },
  { name: 'createdDTG', title: 'Created DTG', type: 'date' },
];
